import { createFileRoute } from "@tanstack/react-router";
import { GapPharmacyListPage } from "@/features/contracts/gap-pharmacy-list-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/apteki-gap/")({
	component: GapPharmacyListPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.apteki-gap",
			location.pathname,
		);
	},
});
